export default new class Header {
  constructor() {
    this.headerContainerSelector = 'header';
    this.mobileNavSelector = 'mobile-nav';
    this.headerHideClass = 'header__hidden';
    this.mobileNavHideClass = 'mobile-nav__hidden';

    this.handler();
  }

  handler() {
    this.previousScroll = 0;
    const header = document.querySelector(`.${this.headerContainerSelector}`);
    const mobileNav = document.querySelector(`.${this.mobileNavSelector}`);

    const headerHiddenClass = this.headerHideClass;
    const mobileNavHiddenClass = this.mobileNavHideClass;


    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;

      if (currentScroll > this.previousScroll && currentScroll > 10) {
        header.classList.add(headerHiddenClass);
        mobileNav.classList.add(mobileNavHiddenClass);
      } else {
        header.classList.remove(headerHiddenClass);
        mobileNav.classList.remove(mobileNavHiddenClass);
      }
      this.previousScroll = currentScroll;
    });
  }
}();
